export default [
	'-None-',
	'1Lt.',
	'1stLt.',
	'2Lt.',
	'2ndLt.',
	'Amb.',
	'Amb. & Mrs.',
	'BG',
	'BGen.',
	'BrigGen.',
	'Brother',
	'CAPT',
	'CDR',
	'COL',
	'CPT',
	'Capt.',
	'Capt. & Mrs.',
	'Col.',
	'Col. & Mrs.',
	'Dean',
	'Dr.',
	'Dr. & Mrs.',
	'Drs.',
	'ENS',
	'Est. of',
	'GEN',
	'Gen.',
	'Gen. & Mrs.',
	'Gov.',
	'Hon.',
	'Hon. & Mrs.',
	'Justice',
	'LCDR',
	'LCDR & Mrs.',
	'LCpl',
	'LT',
	'LTC',
	'LTG',
	'LTJG',
	'Lt.',
	'LtCol.',
	'LtGen.',
	'MAJ',
	'MG',
	'MSG',
	'MSgt.',
	'Maj.',
	'MajGen.',
	'Mayor',
	'Mdme.',
	'Miss',
	'Mr.',
	'Mr. & Dr.',
	'Mr. & Mrs.',
	'Mrs.',
	'Ms.',
	'Msgr.',
	'Mx.',
	'Mx. & Mx.',
	'Prince',
	'Prof.',
	'Prof. & Mrs.',
	'RADM',
	'RT. REV.',
	'Rabbi',
	'Rev.',
	'Rev. & Mrs.',
	'Rev. Dr.',
	'Rev. Dr. & Mrs.',
	'Rev. Father',
	'Senator',
	'Sir',
	'Sister',
];
